let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Z4ij")).then(() => parcelRequire('d9xKq'));